var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.42622 8.9675C6.85788 4.65583 8.07372 2.5 9.99955 2.5C11.9245 2.5 13.1412 4.65583 15.5729 8.9675L15.8762 9.505C17.897 13.0883 18.9079 14.88 17.9945 16.19C17.0812 17.5 14.8212 17.5 10.3029 17.5H9.69622C5.17788 17.5 2.91788 17.5 2.00455 16.19C1.09122 14.88 2.10205 13.0883 4.12288 9.505L4.42622 8.9675ZM9.99955 6.04167C10.1653 6.04167 10.3243 6.10751 10.4415 6.22472C10.5587 6.34193 10.6245 6.50091 10.6245 6.66667V10.8333C10.6245 10.9991 10.5587 11.1581 10.4415 11.2753C10.3243 11.3925 10.1653 11.4583 9.99955 11.4583C9.83379 11.4583 9.67482 11.3925 9.55761 11.2753C9.4404 11.1581 9.37455 10.9991 9.37455 10.8333V6.66667C9.37455 6.50091 9.4404 6.34193 9.55761 6.22472C9.67482 6.10751 9.83379 6.04167 9.99955 6.04167ZM9.99955 14.1667C10.2206 14.1667 10.4325 14.0789 10.5888 13.9226C10.7451 13.7663 10.8329 13.5543 10.8329 13.3333C10.8329 13.1123 10.7451 12.9004 10.5888 12.7441C10.4325 12.5878 10.2206 12.5 9.99955 12.5C9.77853 12.5 9.56657 12.5878 9.41029 12.7441C9.25401 12.9004 9.16622 13.1123 9.16622 13.3333C9.16622 13.5543 9.25401 13.7663 9.41029 13.9226C9.56657 14.0789 9.77853 14.1667 9.99955 14.1667Z",
    fill: "#E3A70B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.848054b472a19c908ffbf2dcd6dfc044.svg";
export { ForwardRef as ReactComponent };